import React, { useState } from 'react';
import '../styles/Testimonials.css';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const testimonials = [
    {
      id: 1,
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean pellentesque suscipit justo, ac lacinia nunc vehicula a. In nec lorem quis neque pulvinar faucibus ac ac sapien. Etiam convallis ut imperdiet ultricies enim mauris iaculis Nunc convallis.",
      author: "ELLEN BOAT",
      rating: 5,
      image: require('../assets/images/s2_1.jpg')
    },
    {
      id: 2,
      text: "Working with Horazel Photography was an absolute pleasure. Their attention to detail and artistic vision exceeded all expectations. Every shot was perfectly composed and captured the essence of our brand.",
      author: "JAMES WILSON",
      rating: 5,
      image: require('../assets/images/s2_2.jpg')
    },
    {
      id: 3,
      text: "The team's professionalism and creativity brought our vision to life. Their ability to capture authentic moments while maintaining technical perfection is truly remarkable. Highly recommended!",
      author: "SARAH MITCHELL",
      rating: 5,
      image: require('../assets/images/s2_3.jpg')
    }
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const current = testimonials[currentIndex];

  return (
    <section className="testimonials-section">
      <div 
        className="testimonial-background"
        style={{ backgroundImage: `url(${current.image})` }}
      >
        <div className="testimonial-overlay"></div>
      </div>
      
      <div className="container testimonial-content">
        <div className="testimonial-inner">
          <div className="quote-icon">"</div>
          
          <div className="stars-rating">
            {[...Array(current.rating)].map((_, i) => (
              <span key={i} className="star">★</span>
            ))}
          </div>
          
          <p className="testimonial-text">{current.text}</p>
          
          <p className="testimonial-author">{current.author}</p>
          
          <div className="testimonial-nav">
            <button 
              onClick={prevTestimonial} 
              className="nav-btn nav-prev"
              aria-label="Previous testimonial"
            >
              ‹
            </button>
            <button 
              onClick={nextTestimonial} 
              className="nav-btn nav-next"
              aria-label="Next testimonial"
            >
              ›
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
